export class PbhRequestAlternatePnPostModel {
  public RequestId?: number;
  public AlternatePn?: string;
  public Status?: number;
}

export class PbhRequestAlternatePnPutModel {
  public id?: number;
  public RequestId?: number;
  public AlternatePn?: string;
  public Note?: string;
  public Status?: number;
  public UpdatedBy?: string;
  public UpdatedDate?: Date;
}
